import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const EMPRESA_KEY = 'empresa-activa';

export default new Vuex.Store({
  state: {
    usuario: {
      rol: '',
    },
    sidebarCollapsed: false,
    empresaActiva: (() => {
      const saved = localStorage.getItem(EMPRESA_KEY);
      return saved ? Number(saved) : null;
    })(),
  },
  getters: {
    userRol: state => state.usuario.rol,
    sidebarCollapsed: state => state.sidebarCollapsed,
    empresaActiva: state => state.empresaActiva,
  },
  mutations: {
    setUserRol(state, rol) {
      state.usuario.rol = rol;
    },
    setSidebarCollapsed(state, val) {
      state.sidebarCollapsed = val;
    },
    setEmpresaActiva(state, id) {
      state.empresaActiva = id;
      if (id != null) {
        localStorage.setItem(EMPRESA_KEY, id);
      } else {
        localStorage.removeItem(EMPRESA_KEY);
      }
    },
  },
  actions: {
    setUserRol({ commit }, rol) {
      commit('setUserRol', rol);
    },
    setSidebarCollapsed({ commit }, val) {
      commit('setSidebarCollapsed', val);
    },
    setEmpresaActiva({ commit }, id) {
      commit('setEmpresaActiva', id);
    },
  }
});